import { type ReactNode } from 'react'

import { Text } from '@procurify/ui'

import { AiActionBannerStyled } from './styles/AiActionBannerStyled'

interface IAiActionBannerProps {
  action: ReactNode
  children: ReactNode
  icon?: ReactNode
  analyticsId?: string
}

export const AiActionBanner = ({
  action,
  children,
  icon,
  analyticsId,
}: IAiActionBannerProps) => (
  <AiActionBannerStyled
    analyticsId={analyticsId}
    action={action}
    {...(icon !== undefined ? { icon } : {})}
  >
    <Text bold breakWord>
      {children}
    </Text>
  </AiActionBannerStyled>
)
